<div *ngIf="grupos.length === 0" class="text-center p-3">
  No hay equipos asignados actualmente
</div>

<mat-accordion *ngIf="grupos.length > 0" multi="true">
  <mat-expansion-panel *ngFor="let grupo of grupos">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ grupo.trabajadorNombre }}
        <mat-icon *ngIf="grupo.pendienteVencido" color="warn" class="ml-2" matTooltip="Lleva más de 30 días sin vincularse a un trabajador real, revisar">
          warning
        </mat-icon>
        <mat-icon *ngIf="grupo.finiquitado" color="warn" class="ml-2" matTooltip="Este trabajador está finiquitado y aún tiene equipos activos sin devolver">
          person_off
        </mat-icon>
      </mat-panel-title>
      <mat-panel-description>
        {{ grupo.rut ? (grupo.rut | formatoRut) : 'Sin vincular' }} · {{ grupo.equipos.length }} equipo(s)
        <span *ngIf="grupo.pendienteVencido" class="text-warning ml-1">· Vencido, revisar</span>
        <span *ngIf="grupo.finiquitado" class="text-warning ml-1">· Finiquitado</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="mb-2">
      <button mat-button color="primary" type="button" (click)="toggleHistorial(grupo)">
        <mat-icon>history</mat-icon>
        {{ grupo.verHistorial ? 'Ver solo activos' : 'Ver historial completo' }}
      </button>
      <span *ngIf="grupo.cargandoHistorial">Cargando...</span>
    </div>

    <table *ngIf="!grupo.verHistorial" mat-table [dataSource]="grupo.equipos" class="w-100">

      <ng-container matColumnDef="movimiento">
        <th mat-header-cell *matHeaderCellDef>Movimiento</th>
        <td mat-cell *matCellDef="let row">{{ row.tipoMovimiento }}</td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let row">{{ row.EquipoTecnologico?.tipo }}</td>
      </ng-container>

      <ng-container matColumnDef="marca">
        <th mat-header-cell *matHeaderCellDef>Marca</th>
        <td mat-cell *matCellDef="let row">{{ row.EquipoTecnologico?.marca }}</td>
      </ng-container>

      <ng-container matColumnDef="modelo">
        <th mat-header-cell *matHeaderCellDef>Modelo</th>
        <td mat-cell *matCellDef="let row">{{ row.EquipoTecnologico?.modelo }}</td>
      </ng-container>

      <ng-container matColumnDef="numeroSerie">
        <th mat-header-cell *matHeaderCellDef>N° Serie</th>
        <td mat-cell *matCellDef="let row">{{ row.EquipoTecnologico?.numeroSerie }}</td>
      </ng-container>

      <ng-container matColumnDef="fechaMovimiento">
        <th mat-header-cell *matHeaderCellDef>Entregado</th>
        <td mat-cell *matCellDef="let row">{{ row.fechaMovimiento | date: 'dd-MM-yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let row"><span class="text-success">ACTIVO</span></td>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let row">
          <button *ngIf="!row.fk_trabajador" mat-icon-button color="accent" matTooltip="Vincular a un trabajador" (click)="abrirVincularTrabajador(row)">
            <mat-icon>link</mat-icon>
          </button>
          <button mat-icon-button color="accent" matTooltip="Editar" (click)="abrirEditarMovimiento(row)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="primary" matTooltip="Ver PDF" (click)="verPdf(row)">
            <mat-icon>picture_as_pdf</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Reportar incidente (pérdida/robo/daño)" (click)="abrirReportarIncidente(row)">
            <mat-icon>report_problem</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['movimiento', 'tipo', 'marca', 'modelo', 'numeroSerie', 'fechaMovimiento', 'estado', 'acciones']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['movimiento', 'tipo', 'marca', 'modelo', 'numeroSerie', 'fechaMovimiento', 'estado', 'acciones'];"></tr>
    </table>

    <table *ngIf="grupo.verHistorial" mat-table [dataSource]="grupo.historial" class="w-100">

      <ng-container matColumnDef="tipoMovimiento">
        <th mat-header-cell *matHeaderCellDef>Movimiento</th>
        <td mat-cell *matCellDef="let row">{{ row.tipoMovimiento }}</td>
      </ng-container>

      <ng-container matColumnDef="equipoHist">
        <th mat-header-cell *matHeaderCellDef>Equipo</th>
        <td mat-cell *matCellDef="let row">
          {{ row.EquipoTecnologico?.marca }} {{ row.EquipoTecnologico?.modelo }} (S/N: {{ row.EquipoTecnologico?.numeroSerie }})
        </td>
      </ng-container>

      <ng-container matColumnDef="estadoActual">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let row">
          <span [class.text-success]="row.estadoActual === 'ACTIVO'" [class.text-muted]="row.estadoActual === 'DEVUELTO'">
            {{ row.estadoActual }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="fechaMovimientoHist">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let row">{{ row.fechaMovimiento | date: 'dd-MM-yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="accionesHist">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="accent" matTooltip="Editar" (click)="abrirEditarMovimiento(row)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="primary" matTooltip="Ver PDF" (click)="verPdf(row)">
            <mat-icon>picture_as_pdf</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['tipoMovimiento', 'equipoHist', 'estadoActual', 'fechaMovimientoHist', 'accionesHist']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['tipoMovimiento', 'equipoHist', 'estadoActual', 'fechaMovimientoHist', 'accionesHist'];"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center" colspan="5">Sin movimientos</td>
      </tr>
    </table>
  </mat-expansion-panel>
</mat-accordion>
